import React, { useState } from "react";
import Sidebar from "../components/Sidebar.jsx";

const Layout = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex h-screen w-full">
      <div
        className={`transition-all duration-300 ${
          isExpanded ? "w-[18%]" : "w-[4%]"
        }`}
      >
        <Sidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
      </div>
      <div
        className={`transition-all duration-300 ${
          isExpanded ? "w-[82%]" : "w-[96%]"
        } p-1`}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
